export default "__VITE_ASSET__DtpdZa6R__"